import React from 'react';

const Badge = ({ text }) => {
  return (
    <>
      <style>
        {`
          .custom-badge-wrapper {
            margin-bottom: 5px;
            display: flex;
          
          }

          .custom-badge-container {
            display: inline-flex;
            align-items: center;
            background-color: #ffffff;
            color: #2b4d8d;
            font-family: 'hauora-medium', sans-serif;
            font-weight: 700;
            font-size: 15px;
            padding: 8px 25px;
            border-radius: 50px;
            letter-spacing: 0.3px;
            /* Why Choose Us এর সেই সিগনেচার শ্যাডো */
            box-shadow: 0 0 20px rgba(178, 35, 53, 0.25);
            border: 1px solid rgba(178, 35, 53, 0.1);
          }

          .custom-badge-dot {
            height: 8px;
            width: 8px;
            background-color: #b22335;
            border-radius: 50%;
            display: inline-block;
            margin-right: 12px;
            flex-shrink: 0;
          }

          @media (max-width: 576px) {
            .custom-badge-container {
              font-size: 13px;
              padding: 7px 18px;
            }
          }
        `}
      </style>

      <div className="custom-badge-wrapper">
        <div className="custom-badge-container">
          <span className="custom-badge-dot"></span>
          {text}
        </div>
      </div>
    </>
  );
};

export default Badge;